import angular from 'angular'
import importSettingCtrl from './importSettingCtrl'
// import { Router, RouterList, RouterSetting } from './Routers'

import {
    importSetting
} from 'redevConfig'


const add = (importSetting && importSetting.add) || ''
const list = (importSetting && importSetting.list) || ''

const importSettingListCtrl = list ? require(`redevelopment/system/importSetting/${list.controllerName}`) : require('./importSettingListCtrl')
const importSettingSettingCtrl = add ? require(`redevelopment/system/importSetting/${add.controllerName}`) : require('./importSettingSettingCtrl')

const listPage = list ? require(`redevelopment/system/importSetting/${list.templateName}`) : require('./views/importSettingList.html')
const addPage = add ? require(`redevelopment/system/importSetting/${add.templateName}`) : require('./views/importSettingSetting.html')

export default angular
    .module('system.settingcenter.importSetting', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.settingcenter.importSetting', {
                abstract: true,
                url: '/importSetting',
                template: '<div ui-view></div>',
                // controller: 'importSettingCtrl',
                title: '导入模板',
                default: 'system.settingcenter.importSetting.list',
            })
            .state('system.settingcenter.importSetting.list', {
                url: '/list',
                template: listPage,
                controller: 'importSettingListCtrl',
            })
            .state('system.settingcenter.importSetting.add', {
                url: '/add/:id/:type',
                template: addPage,
                controller: 'importSettingSettingCtrl',
                title: '新增',
            })
    }])
    .controller('importSettingCtrl', importSettingCtrl)
    .controller('importSettingListCtrl', importSettingListCtrl.default)
    .controller('importSettingSettingCtrl', importSettingSettingCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/importSetting/index.js